import React from 'react';

const DesignOrderModal = () => {
	return (
		<div className="wraper container-fluid dashboard-container">
			<div className="popup-wrapper">
				<div className="common-popup products-upload-modal">
					<div className="common-popup-header d-flex justify-content-between">
						<div className="popup-tilte">
							<h3 className="semibold-16 mb-0">Create project</h3>
						</div>
						<div className="close-btn">
							<img alt="close" src=" /icons/close.svg" />
						</div>
					</div>
					<div className="common-popup-body">
						<div className="row">
							<div className="col-md-12 pr-2">
								<div className="form-group">
									<label htmlFor="collection">Project Name</label>
									<input type="text" />
								</div>
							</div>
							<div className="col-md-6 pr-2">
								<div className="form-group">
									<div className="select-component">
										<label htmlFor="collection">Project type</label>
										<div className="click-box click mb-1" data-toggle="dropdown">
											<p className="regular-14 ">select</p>
											<img src=" /images/chevron_down.svg" />
										</div>
										<div className="dropdown-box dropdown-menu">
											<div className="m-0 search-filter">
												<div className="with-icon right-icon">
													<input placeholder="Search" type="text" />
													<span className="right-icon">
														<img src=" /icons/search.png" />
													</span>
												</div>
											</div>
											<div className="list-items scroll-y-label">
												<div className="single-item">
													<p>Garments</p>
												</div>
												<div className="single-item">
													<p>Item 2</p>
												</div>
												<div className="single-item">
													<p>Item 3</p>
												</div>
												<div className="single-item">
													<p>Item 4</p>
												</div>
												<div className="single-item">
													<p>Item 5</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className="form-group">
									<div className="select-component">
										<label htmlFor="collection">Project Owner</label>
										<div className="click-box click mb-1" data-toggle="dropdown">
											<p className="regular-14 ">select</p>
											<img src=" /images/chevron_down.svg" />
										</div>
										<div className="dropdown-box dropdown-menu">
											<div className="m-0 search-filter">
												<div className="with-icon right-icon">
													<input placeholder="Search" type="text" />
													<span className="right-icon">
														<img src=" /icons/search.png" />
													</span>
												</div>
											</div>
											<div className="list-items scroll-y-label">
												<div className="single-item">
													<p>Garments</p>
												</div>
												<div className="single-item">
													<p>Item 2</p>
												</div>
												<div className="single-item">
													<p>Item 3</p>
												</div>
												<div className="single-item">
													<p>Item 4</p>
												</div>
												<div className="single-item">
													<p>Item 5</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>

							<div className="col-md-6 pr-2">
								<div className="form-group">
									<label htmlFor="collection">Project start date</label>
									<input type="date" />
								</div>
							</div>
							<div className="col-md-6 pr-2">
								<div className="form-group">
									<label htmlFor="collection">Project end date</label>
									<input type="date" />
								</div>
							</div>
							<div className="col-md-6 pr-2">
								<div className="form-group">
									<div className="select-component">
										<label htmlFor="collection">Brand</label>
										<div className="click-box click mb-1" data-toggle="dropdown">
											<p className="regular-14 ">select</p>
											<img src=" /images/chevron_down.svg" />
										</div>
										<div className="dropdown-box dropdown-menu">
											<div className="m-0 search-filter">
												<div className="with-icon right-icon">
													<input placeholder="Search" type="text" />
													<span className="right-icon">
														<img src=" /icons/search.png" />
													</span>
												</div>
											</div>
											<div className="list-items scroll-y-label">
												<div className="single-item">
													<p>Garments</p>
												</div>
												<div className="single-item">
													<p>Item 2</p>
												</div>
												<div className="single-item">
													<p>Item 3</p>
												</div>
												<div className="single-item">
													<p>Item 4</p>
												</div>
												<div className="single-item">
													<p>Item 5</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-6">
								<div className="form-group">
									<div className="select-component">
										<label htmlFor="collection">Buyer 1st meeting date</label>
										<div className="click-box click mb-1" data-toggle="dropdown">
											<p className="regular-14 ">select</p>
											<img src=" /images/chevron_down.svg" />
										</div>
										<div className="dropdown-box dropdown-menu">
											<div className="m-0 search-filter">
												<div className="with-icon right-icon">
													<input placeholder="Search" type="text" />
													<span className="right-icon">
														<img src=" /icons/search.png" />
													</span>
												</div>
											</div>
											<div className="list-items scroll-y-label">
												<div className="single-item">
													<p>Garments</p>
												</div>
												<div className="single-item">
													<p>Item 2</p>
												</div>
												<div className="single-item">
													<p>Item 3</p>
												</div>
												<div className="single-item">
													<p>Item 4</p>
												</div>
												<div className="single-item">
													<p>Item 5</p>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="collection">Style category details (Optional)</label>
									<textarea name="" id="" placeholder="description" />
								</div>
							</div>
							<div className="col-md-12">
								<div className="form-group">
									<label htmlFor="collection">Fabric details (Optional)</label>
									<textarea name="" id="" placeholder="description" />
								</div>
							</div>
						</div>
					</div>
					<div className="modal-footer">
						<div className="footer-buttons text-right">
							<button className="button outline size32 ml-2">Cancel</button>
							<button className="button size32 ml-2">Submit</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
};

export default DesignOrderModal;
